import React from 'react';
import { RouterConfig } from '../../config/router';
import { UnderOverMenu } from '../../components/UnderOverMenu';

const allPageTile = [
  {
    title: '0.5',
    over: RouterConfig.OverZero,
    under: RouterConfig.UnderZero,
  },
  {
    title: '1.5',
    over: RouterConfig.OverOne,
    under: RouterConfig.UnderOne,
  },
  {
    title: '2.5',
    over: RouterConfig.OverTwo,
    under: RouterConfig.UnderTwo,
  },
  {
    title: '3.5',
    over: RouterConfig.OverThree,
    under: RouterConfig.UnderThree,
  },
  {
    title: '4.5',
    over: RouterConfig.OverFour,
    under: RouterConfig.UnderFour,
  },
];

export default function UnderOverGoals() {
  return <UnderOverMenu menu={allPageTile} title="Wybór goli" />;
}
